module.exports = __webpack_public_path__ + "img/ZM.3a8e47fa.svg";